import React from 'react';
import Dialog from '../../../components/Dialog';
import { IconTrash } from '../../../components/dialogIcons';

/*
  Taking one line off a count sheet.

  Ported onto the shared dialog shell on 5 September 2026, to Group E's approved
  drawing `dialog-remove-line-*.png`.

  **It says what is being taken and what has been counted against it**, which
  the old one did not: it named the item and warned in general terms, and a rep
  removing the wrong line lost a number they had already been to the shelf for
  with nothing to say so.
*/
export default function RemoveModal({ item, onConfirm, onClose }) {
  const counted = item.quantity === null || item.quantity === undefined ? null : item.quantity;
  return (
    <Dialog
      kind="danger" icon={<IconTrash />} size="question"
      title="Remove this line"
      record={item.item_number_raw}
      onClose={onClose}
      footer={
        <>
          <button className="btn btn-quiet" onClick={onClose}>Keep it</button>
          <button className="btn btn-danger" onClick={() => onConfirm(item.id)}>Remove the line</button>
        </>
      }
    >
      <p style={{ fontSize: 14, color: 'var(--text-strong)', lineHeight: 1.6, margin: 0 }}>
        Take <strong>{item.item_number_raw}, {item.description_raw}</strong>, off this sheet?
        {counted !== null && <> It has <strong>{counted}</strong> counted against it.</>}
      </p>
      <div style={{ marginTop: 14, borderRadius: 12, padding: '12px 14px', background: 'var(--critical-bg)', color: 'var(--critical-ink)', fontSize: 13, lineHeight: 1.55 }}>
        This cannot be undone. Removed by mistake, the line has to be added again and counted again.
      </div>
    </Dialog>
  );
}
